import * as React from 'react';
import { useHistory } from 'react-router-dom';
import axios from 'axios';
import PageContent from '../../components/layout/PageContent';
import CustomForm from '../../components/form/CustomForm';
import { handleFormImageUpload } from '../../utils';
import { enums, enumDictionary } from './helper';

const EditCountry = ({
	location: { state: { id = null } = {} } = {},
}) => {

	const history = useHistory();
	
	const [ fields, setFields ] = React.useState([]);

	React.useEffect(() => {
		axios.get(`/api/country/${id}`)
		.then(({ data = {} }) => {
			const { result = {  } } = data;
			const responseFields = (result?.data ?? []).map((field) => {
				if (field.key === "image") {
					return {
						...field,
						value: [{
							url: field?.value || null,
						}]
					};
				};
				if (field.key === 'logo') {
					return {
						...field,
						instance: 'string',
						enum: enums,
						enumDictionary,
					}
				};
				return {
					...field,
				};
			});
			setFields(responseFields);
		})
		.catch(err => {
			console.log(err);
		})
	}, [id]);

	const handleSubmit = (fields) => {
		axios.post(`/api/country/${id}`, fields)
		.then(({ data }) => {
			if (data.statusCode === 200) {
				history.push('/country');
			}
		})
		.catch(err => {
			console.log(err);
		})
	}

	const handleCancel = () => {
		history.push('/country')
	};

	return (
		<PageContent
			background="#fff"
			subheader={{
				title: 'Улсын мэдээлэл засах',
				background: '#ffffff'
			}}
		>
			<CustomForm
				fields={fields}
				onSubmit={handleSubmit}
				onCancel={handleCancel}
				imageUpload={handleFormImageUpload}
			/>
		</PageContent>
	)
}

export default EditCountry;